import { IDeletedFile, IFile, IQnaDetail, ITalkReply } from "./qnaDetail.types";

export class QnaInfoDetail implements IQnaDetail {
  readonly uid: string;
  readonly serviceUid: string;
  readonly talkBbsCode: string;
  readonly talkTypeCode: string;
  readonly talkBbsName: string;
  readonly talkTypeName: string;
  readonly writerUid: string;
  readonly writerName: string;
  readonly tenantUid: string;
  readonly readYn: boolean;
  readonly useBeginDtm: string;
  readonly topYn: boolean;
  readonly popupYn: boolean;
  readonly displayYn: boolean;
  readonly statusCode: string;
  readonly statusName: string;
  readonly createdTs: string;
  readonly savedTs: string;
  readonly updatedTs?: string;
  readonly talkReplies?: ITalkReply[];
  qnaTypeCode: string;
  title: string;
  bodyText?: string;
  secretYn: boolean;
  campusCode?: string;
  boardLineRoute?: string;
  boardDtm?: string;
  files?: IFile[];
  deletedFiles?: IDeletedFile[];

  constructor(data: IQnaDetail) {
    this.uid = data.uid;
    this.serviceUid = data.serviceUid;
    this.talkBbsCode = data.talkBbsCode;
    this.talkTypeCode = data.talkTypeCode;
    this.talkBbsName = data.talkBbsName;
    this.talkTypeName = data.talkTypeName;
    this.writerUid = data.writerUid;
    this.writerName = data.writerName;
    this.tenantUid = data.tenantUid;
    this.readYn = data.readYn;
    this.useBeginDtm = data.useBeginDtm;
    this.topYn = data.topYn;
    this.popupYn = data.popupYn;
    this.displayYn = data.displayYn;
    this.statusCode = data.statusCode;
    this.statusName = data.statusName;
    this.createdTs = data.createdTs;
    this.savedTs = data.savedTs;
    this.updatedTs = data.updatedTs;
    this.talkReplies = data.talkReplies;
    this.qnaTypeCode = data.qnaTypeCode;
    this.title = data.title;
    this.bodyText = data.bodyText;
    this.secretYn = data.secretYn;
    this.campusCode = data.campusCode;
    this.boardLineRoute = data.boardLineRoute;
    this.boardDtm = data.boardDtm;
    this.files = data.files;
    this.deletedFiles = data.deletedFiles;
  }
}
